import icon1 from '../careers/careersImage/icon1.svg';
import icon2 from '../careers/careersImage/icon2.svg';
import icon3 from '../careers/careersImage/icon3.svg';
import icon4 from '../careers/careersImage/icon4.svg';
import icon5 from '../careers/careersImage/icon5.svg';
import icon6 from '../careers/careersImage/icon6.svg';
import iconSeven from '../careers/careersImage/awards-recognition.png';
import icon8 from '../careers/careersImage/icon8.png';
import icon9 from '../careers/careersImage/icon9.png';
import icon10 from '../careers/careersImage/icon10.png';


const benefits = [
  {
    icon: icon1,
    title: "5 Days a Week",
    description:
      "Weekends off are a great way to take rest, have a break for family and friends and get self a recharge for the upcoming work week.",
  },
  {
    icon: icon3,
    title: "Flexible Timings",
    description:
      "We empower employees to manage things in a fast-paced work environment; that balance your work & personal lives, which leads to productivity in the office.",
  },
  {
    icon: icon4,
    title: "Open Work Culture",
    description:
      "We trust in open communication, collaboration & teamwork that foster a positive environment and inspire everyone to be involved deeply in the process of growth.",
  },
  {
    icon: icon5,
    title: "On-site Opportunity",
    description:
      "It's called to be a great opportunity for the employees, as this boosts their confidence and to take roles and responsibilities of the project sincerely.",
  },
  {
    icon: icon6,
    title: "Workshops & Webinars",
    description:
      "We offer regular training & mentoring from experts and mentors that help employees to stay up-to-date with the latest industry trends and enhance skills.",
  },
  {
    icon: iconSeven,
    title: "Awards & Recognition",
    description:
      "To appreciate the performance of the employees, we conduct an annual reward ceremony that can boost their morale and increase employee engagement.",
  },
  {
    icon: icon8,
    title: "Corporate Infrastructure",
    description:
      "Bigger space with a comfortable and well-equipped workstation, partitioned meeting rooms, re-creation area & collaboration rooms.",
  }, {
    icon: icon9,
    title: "People First",
    description:
      "Our people-first values guide everything we do, from hiring to decision-making. Check out what our employees say about their experiences with TekIT at Glassdoor.",
  }, {
    icon: icon10,
    title: "Dazzling Festive Celebration",
    description:
      "We love celebrating festivals with great enthusiasm, using various themes & decorations which help employees feel more welcomed and connected.",
  },
];

export default function ThinkwikBenefits() {
  return (
    <div className="bg-[#111111] text-white px-6 py-16 font-recoleta">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-[60px] 2xl:text-[40px] lg:text-[32px] font-bold mb-4" data-aos="fade-up">
        Want to shape the Future of Tech — Start at TekIT
        </h2>
        <p className="text-gray-300 lg:max-w-3xl  text-[32px] 2xl:text-[26px] lg:text-[20px]  mx-auto" data-aos="fade-up">
        At TekIT, we don’t just offer jobs — we offer career journeys. Whether you're a developer, designer, analyst, or project manager, we provide the platform, mentorship, and challenges to help you grow and thrive. Our culture is built on innovation, collaboration, and work-life balance, where your ideas matter and your efforts are recognized. We maintain a strict no-politics environment, ensuring transparency, mutual respect, and a focus on what truly matters — delivering great work together. Join a team that empowers you to make an impact from day one.
        </p>
      </div>

      <div className="grid-cols-1 lg:grid-cols-2 lg:mt-0 mt-28 max-w-6xl mx-auto lg:block hidden">
        {benefits.map((item, index) => (
          <div key={index} className=" gap-4 px-5 lg:items-start items-center pb-6">

            <div>
              <div className='lg:flex gap-4 '>
                <div className='lg:w-10 w-60 justify-self-center'>
                  <img src={item.icon} className="mt-1 lg:w-20 w-40" data-aos="fade-right" />
                </div>
                <h3 data-aos="fade-left" className="font-semibold lg:text-start text-center lg:mt-0 mt-10 lg:content-center 2xl:text-[26px]  lg:text-[20px] text-[54px]">{item.title}</h3>
              </div>
            </div>
            <div>
              <p data-aos="fade-up" className="text-gray-200 text-[42px] 2xl:text-[20px]  lg:text-[16px] text-center lg:text-start py-4 mt-1">{item.description}</p>
            </div>

          </div>
        ))}
      </div>

      {/* <div className="lg:mt-0 mt-28 block lg:hidden w-full">
  {benefits.map((item, index) => (
    <div
      key={index}
      className="w-full px-5 pb-6 flex flex-col items-center text-center"
    >
      <div className="w-full flex justify-center">
        <img
          src={item.icon}
          className="w-full max-w-[160px] h-auto"
          data-aos="fade-right"
          alt=""
        />
      </div>

      <div className="w-full">
        <h6
          data-aos="fade-left"
          className="font-semibold mt-10 text-[20px] w-full"
        >
          {item.title}
        </h6>

        <p
          data-aos="fade-up"
          className="text-gray-200 text-[42px] py-4 mt-1 w-full"
        >
          {item.description}
        </p>
      </div>
    </div>
  ))}
</div> */}

<div className="lg:mt-0 mt-28 block lg:hidden w-full">
  {benefits.map((item, index) => (
    <div
      key={index}
      className="w-full px-5 pb-6 flex flex-col items-center text-center"
    >
      {/* Icon */}
      <img
        src={item.icon}
        className="w-full max-w-[160px] mx-auto"
        data-aos="fade-right"
        alt=""
      />

      {/* Title */}
      <div className="w-[88%] mt-10">
        <h6
          data-aos="fade-left"
          className="font-semibold text-[48px] leading-tight w-full"
        >
          {item.title}
        </h6>
      </div>

      {/* Description */}
      <div className="w-full">
        <p
          data-aos="fade-up"
          className="text-gray-200 text-[42px] leading-snug mt-4 w-full"
        >
          {item.description}
        </p>
      </div>
    </div>
  ))}
</div>



    </div>
  );
}
